export { default } from '@/src/features/voice-assessment/components/VoiceAssessmentIndexRoute'
